import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountElementService } from 'app/core/services/account-element.service';

@Component({
  selector: 'dialog-add-element',
  templateUrl: './dialog-add-element.component.html',
  styleUrls: ['./dialog-add-element.component.scss']
})
export class DialogAddElementComponent implements OnInit {
  isLoading: boolean = false;
  elementForm: FormGroup;
  type: any = [];
  sign: any = [];

  constructor(public dialogRef: MatDialogRef<DialogAddElementComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private accountElementService: AccountElementService) {
      this.elementForm = this.fb.group({
        id: [0],
        elementId: [this.data.elementId],
        name: ['', Validators.required],
        type: [null, Validators.required],
        sign: [null, Validators.required],
        summaryLevel: [false, Validators.required],
        docControlled: [false],
        bankAccount: [false],
        manageBP: [false],
        manageProd: [false],
        postActual: [false],
        postBudget: [false],
        postStatistical: [false],
      });
      
      this.elementForm.get('summaryLevel')?.valueChanges.subscribe((value: boolean) => {
        const controlsToToggle = [
          'docControlled',
          'bankAccount',
          'manageBP',
          'manageProd',
          'postActual',
          'postBudget',
          'postStatistical',
        ];
      
        if (value) {
          controlsToToggle.forEach(control => {
            this.elementForm.get(control)?.clearValidators();
            this.elementForm.get(control)?.updateValueAndValidity();
          });
        } else {
          controlsToToggle.forEach(control => {
            this.elementForm.get(control)?.setValidators(Validators.required);
            this.elementForm.get(control)?.updateValueAndValidity();
          });
        }
      
        controlsToToggle.forEach(control => {
          this.elementForm.get(control)?.updateValueAndValidity();
        });
      });
  }

  ngOnInit(): void {
    this.getAccountType();
    this.getAccountSign();
    if (this.data?.selectedElement?.C_ElementValue_ID > 0) {
      console.log(this.data.selectedElement);
      const selectedElement = this.data.selectedElement;
      this.elementForm.patchValue({
        id: selectedElement.C_ElementValue_ID || 0,
        elementId: this.data.elementId || 0,
        name: selectedElement.ElementValueName || '',
        type: selectedElement.ElementType || null,
        sign: selectedElement.AccountSign || null,
        summaryLevel: selectedElement.IsSummaryLevel || false,
        docControlled: selectedElement.IsDocControlled || false,
        bankAccount: selectedElement.IsBankAccount || false,
        manageBP: selectedElement.IsManageBP || false,
        manageProd: selectedElement.IsManageProd || false,
        postActual: selectedElement.IsPostActual || false,
        postBudget: selectedElement.IsPostBudget || false,
        postStatistical: selectedElement.IsPostStatistical || false,
      });
    }
    if (this.data?.elementId > 0) {
      this.elementForm.patchValue({ elementId: this.data.elementId });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getAccountType() {
    this.accountElementService.getAccountType().subscribe({
      next: res => {
        this.type = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getAccountSign() {
    this.accountElementService.getAccountSign().subscribe({
      next: res => {
        this.sign = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  save() {
    this.isLoading = true;
    console.log(this.elementForm.value);
    if (this.elementForm.invalid) {
      Object.keys(this.elementForm.controls).forEach((controlName) => {
        this.elementForm.get(controlName)?.markAsTouched();
        this.isLoading = false;
      });
      return;
    }
    if (this.elementForm.valid) {
      this.accountElementService.createUpdateElementValue(this.elementForm.value).subscribe({
        next: res => {
          this.isLoading = false;
          this.dialogRef.close();
          window.location.reload();
        },
        error: err => {
          console.log(err);
          this.isLoading = false;
        }
      })
    }
  }
}
